import { createSlice } from "@reduxjs/toolkit";
import { getUpcomingCheckins, markCheckinStatus } from "./thunks";

const initialState = {
  checkins: [],
  status: "idle",
  error: null,
  lastFetched: null,
};

export const checkinSlice = createSlice({
  name: "checkin",
  initialState,
  reducers: {
    resetCheckinStatus: (state) => { state.status = 'idle'; state.lastFetched = null; },
  },
  extraReducers: (builder) => {
    builder.addCase(getUpcomingCheckins.pending, (state) => {
      state.status = "loading";
    });

    builder.addCase(getUpcomingCheckins.fulfilled, (state, action) => {
      state.checkins = action.payload || [];
      state.status = "successful";
      state.lastFetched = Date.now();
    });

    builder.addCase(getUpcomingCheckins.rejected, (state, action) => {
      state.status = "failed";
      state.error = action.error;
    });

    builder.addCase(markCheckinStatus.fulfilled, (state, action) => {
      const { reservationId, status } = action.payload;
      state.checkins = state.checkins.map(item =>
        item.reservation_id === reservationId
          ? { ...item, checkin_status: status }
          : item
      );
    });
  },
});

export const urgentCheckinsCount = (state) => {
  const now = new Date();
  const threeDays = new Date();
  threeDays.setDate(now.getDate() + 3);
  const threeDaysStr = threeDays.toISOString().split('T')[0];
  const todayStr = now.toISOString().split('T')[0];

  return state.checkin.checkins.filter(c =>
    c.departure_date <= threeDaysStr &&
    c.departure_date >= todayStr &&
    c.checkin_status !== 'COMPLETADO'
  ).length;
};

export const { resetCheckinStatus } = checkinSlice.actions;

export default checkinSlice.reducer;
